import request from '@/utils/request'

let TableApi = {
  /*列表*/
   getList(data) {
    return request._post('/shop/plus.table_num.tableNum/index', data);
  },
  /*添加*/
  add(data) {
    return request._post('/shop/plus.table_num.tableNum/add', data);
  },
  /*删除*/
  delete(data) {
    return request._get('/shop/plus.table_num.tableNum/delete', data);
  },
  updateStatus(data){
    return request._get('/shop/plus.table_num.tableNum/status', data);
  },
  /*台号设置-基础设置*/
  SaveBasic(data) {
      return request._post('/shop/plus.table_num.setting/basic', data);
  },
  GetBasic(data) {
      return request._get('/shop/plus.table_num.setting/basic', data);
  },
  /*台号设置-台号海报*/
  SaveBackground(data) {
      return request._post('/shop/plus.table_num.setting/qrcode', data);
  },
  /*台号设置-获取台号海报*/
  GetBackground(data) {
      return request._get('/shop/plus.table_num.setting/qrcode', data);
  },
  orderlist(data){
    return request._get('/shop/plus.table_num.order/index', data);
  },
  /*查询推广码*/
  findPosterCode(data) {
      return request._post('/shop/plus.table_num.setting/getPosterCode', data);
  },
  /*重新制作推广码*/
  remakeCode(data) {
      return request._post('/shop/plus.table_num.setting/remakeCode', data);
  },
  /*重新制作推广码*/
  remakeQrcode(data) {
      return request._post('/shop/plus.table_num.setting/remakeQrcode', data);
  },
}
export default TableApi;



// WEBPACK FOOTER //
// ./src/api/table_num.js